import { Model, Schema } from "src/engine/modules/model/classes"

const entityName = `planType`

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `/plan/types/${id}` : `plan/types`),
  primaryKey: `id`,
  schema: new Schema({}),
})
